'use strict';

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return _get(target, property, receiver || target); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr && (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]); if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, '__esModule', {
  value: true
});

var motionDom = require('motion-dom');

var motionUtils = require('motion-utils');

function isDOMKeyframes(keyframes) {
  return _typeof(keyframes) === "object" && !Array.isArray(keyframes);
}

function resolveSubjects(subject, keyframes, scope, selectorCache) {
  if (typeof subject === "string" && isDOMKeyframes(keyframes)) {
    return motionDom.resolveElements(subject, scope, selectorCache);
  } else if (subject instanceof NodeList) {
    return Array.from(subject);
  } else if (Array.isArray(subject)) {
    return subject;
  } else {
    return [subject];
  }
}

function calculateRepeatDuration(duration, repeat, _repeatDelay) {
  return duration * (repeat + 1);
}
/**
 * Given a absolute or relative time definition and current/prev time state of the sequence,
 * calculate an absolute time for the next keyframes.
 */


function calcNextTime(current, next, prev, labels) {
  if (typeof next === "number") {
    return next;
  } else if (next.startsWith("-") || next.startsWith("+")) {
    return Math.max(0, current + parseFloat(next));
  } else if (next === "<") {
    return prev;
  } else if (next.startsWith("<")) {
    return Math.max(0, prev + parseFloat(next.slice(1)));
  } else {
    var _labels$get;

    return (_labels$get = labels.get(next)) !== null && _labels$get !== void 0 ? _labels$get : current;
  }
}

function eraseKeyframes(sequence, startTime, endTime) {
  for (var i = 0; i < sequence.length; i++) {
    var keyframe = sequence[i];

    if (keyframe.at > startTime && keyframe.at < endTime) {
      motionUtils.removeItem(sequence, keyframe); // If we remove this item we have to push the pointer back one

      i--;
    }
  }
}

function addKeyframes(sequence, keyframes, easing, offset, startTime, endTime) {
  /**
   * Erase every existing value between currentTime and targetTime,
   * this will essentially splice this timeline into any currently
   * defined ones.
   */
  eraseKeyframes(sequence, startTime, endTime);

  for (var i = 0; i < keyframes.length; i++) {
    sequence.push({
      value: keyframes[i],
      at: motionDom.mixNumber(startTime, endTime, offset[i]),
      easing: motionUtils.getEasingForSegment(easing, i)
    });
  }
}
/**
 * Take an array of times that represent repeated keyframes. For instance
 * if we have original times of [0, 0.5, 1] then our repeated times will
 * be [0, 0.5, 1, 1, 1.5, 2]. Loop over the times and scale them back
 * down to a 0-1 scale.
 */


function normalizeTimes(times, repeat) {
  for (var i = 0; i < times.length; i++) {
    times[i] = times[i] / (repeat + 1);
  }
}

function compareByTime(a, b) {
  if (a.at === b.at) {
    if (a.value === null) return 1;
    if (b.value === null) return -1;
    return 0;
  } else {
    return a.at - b.at;
  }
}

var defaultSegmentEasing = "easeInOut";
var MAX_REPEAT = 20;

function createAnimationsFromSequence(sequence) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$defaultTransitio = _ref.defaultTransition,
      defaultTransition = _ref$defaultTransitio === void 0 ? {} : _ref$defaultTransitio,
      sequenceTransition = _objectWithoutProperties(_ref, ["defaultTransition"]);

  var scope = arguments.length > 2 ? arguments[2] : undefined;
  var generators = arguments.length > 3 ? arguments[3] : undefined;
  var defaultDuration = defaultTransition.duration || 0.3;
  var animationDefinitions = new Map();
  var sequences = new Map();
  var elementCache = {};
  var timeLabels = new Map();
  var prevTime = 0;
  var currentTime = 0;
  var totalDuration = 0;
  /**
   * Build the timeline by mapping over the sequence array and converting
   * the definitions into keyframes and offsets with absolute time values.
   * These will later get converted into relative offsets in a second pass.
   */

  var _loop = function _loop(i) {
    var segment = sequence[i];
    /**
     * If this is a timeline label, mark it and skip the rest of this iteration.
     */

    if (typeof segment === "string") {
      timeLabels.set(segment, currentTime);
      return "continue";
    } else if (!Array.isArray(segment)) {
      timeLabels.set(segment.name, calcNextTime(currentTime, segment.at, prevTime, timeLabels));
      return "continue";
    }

    var _segment = _slicedToArray(segment, 3),
        subject = _segment[0],
        keyframes = _segment[1],
        _segment$ = _segment[2],
        transition = _segment$ === void 0 ? {} : _segment$;
    /**
     * If a relative or absolute time value has been specified we need to resolve
     * it in relation to the currentTime.
     */


    if (transition.at !== undefined) {
      currentTime = calcNextTime(currentTime, transition.at, prevTime, timeLabels);
    }
    /**
     * Keep track of the maximum duration in this definition. This will be
     * applied to currentTime once the definition has been parsed.
     */


    var maxDuration = 0;

    var resolveValueSequence = function resolveValueSequence(valueKeyframes, valueTransition, valueSequence) {
      var _duration;

      var elementIndex = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
      var numSubjects = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
      var valueKeyframesAsList = keyframesAsList(valueKeyframes);

      var _valueTransition$dela = valueTransition.delay,
          delay = _valueTransition$dela === void 0 ? 0 : _valueTransition$dela,
          _valueTransition$time = valueTransition.times,
          times = _valueTransition$time === void 0 ? motionDom.defaultOffset(valueKeyframesAsList) : _valueTransition$time,
          _valueTransition$type = valueTransition.type,
          type = _valueTransition$type === void 0 ? "keyframes" : _valueTransition$type,
          repeat = valueTransition.repeat,
          repeatType = valueTransition.repeatType,
          _valueTransition$repe = valueTransition.repeatDelay,
          repeatDelay = _valueTransition$repe === void 0 ? 0 : _valueTransition$repe,
          remainingTransition = _objectWithoutProperties(valueTransition, ["delay", "times", "type", "repeat", "repeatType", "repeatDelay"]);

      var _valueTransition$ease = valueTransition.ease,
          ease = _valueTransition$ease === void 0 ? defaultTransition.ease || "easeOut" : _valueTransition$ease,
          duration = valueTransition.duration;
      /**
       * Resolve stagger() if defined.
       */

      var calculatedDelay = typeof delay === "function" ? delay(elementIndex, numSubjects) : delay;
      /**
       * If this animation should and can use a spring, generate a spring easing function.
       */

      var numKeyframes = valueKeyframesAsList.length;
      var createGenerator = motionDom.isGenerator(type) ? type : generators === null || generators === void 0 ? void 0 : generators[type || "keyframes"];

      if (numKeyframes <= 2 && createGenerator) {
        /**
         * As we're creating an easing function from a spring,
         * ideally we want to generate it using the real distance
         * between the two keyframes. However this isn't always
         * possible - in these situations we use 0-100.
         */
        var absoluteDelta = 100;

        if (numKeyframes === 2 && isNumberKeyframesArray(valueKeyframesAsList)) {
          var delta = valueKeyframesAsList[1] - valueKeyframesAsList[0];
          absoluteDelta = Math.abs(delta);
        }

        var springTransition = _objectSpread({}, remainingTransition);

        if (duration !== undefined) {
          springTransition.duration = motionUtils.secondsToMilliseconds(duration);
        }

        var springEasing = motionDom.createGeneratorEasing(springTransition, absoluteDelta, createGenerator);
        ease = springEasing.ease;
        duration = springEasing.duration;
      }

      (_duration = duration) !== null && _duration !== void 0 ? _duration : duration = defaultDuration;
      var startTime = currentTime + calculatedDelay;
      /**
       * If there's only one time offset of 0, fill in a second with length 1
       */

      if (times.length === 1 && times[0] === 0) {
        times[1] = 1;
      }
      /**
       * Fill out if offset if fewer offsets than keyframes
       */


      var remainder = times.length - valueKeyframesAsList.length;
      remainder > 0 && motionDom.fillOffset(times, remainder);
      /**
       * If only one value has been set, ie [1], push a null to the start of
       * the keyframe array. This will let us mark a keyframe at this point
       * that will later be hydrated with the previous value.
       */

      valueKeyframesAsList.length === 1 && valueKeyframesAsList.unshift(null);
      /**
       * Handle repeat options
       */

      if (repeat) {
        motionUtils.invariant(repeat < MAX_REPEAT, "Repeat count too high, must be less than 20");
        duration = calculateRepeatDuration(duration, repeat);

        var originalKeyframes = _toConsumableArray(valueKeyframesAsList);

        var originalTimes = _toConsumableArray(times);

        ease = Array.isArray(ease) ? _toConsumableArray(ease) : [ease];

        var originalEase = _toConsumableArray(ease);

        for (var repeatIndex = 0; repeatIndex < repeat; repeatIndex++) {
          valueKeyframesAsList.push.apply(valueKeyframesAsList, _toConsumableArray(originalKeyframes));

          for (var keyframeIndex = 0; keyframeIndex < originalKeyframes.length; keyframeIndex++) {
            times.push(originalTimes[keyframeIndex] + (repeatIndex + 1));
            ease.push(keyframeIndex === 0 ? "linear" : motionUtils.getEasingForSegment(originalEase, keyframeIndex - 1));
          }
        }

        normalizeTimes(times, repeat);
      }

      var targetTime = startTime + duration;
      /**
       * Add keyframes, mapping offsets to absolute time.
       */

      addKeyframes(valueSequence, valueKeyframesAsList, ease, times, startTime, targetTime);
      maxDuration = Math.max(calculatedDelay + duration, maxDuration);
      totalDuration = Math.max(targetTime, totalDuration);
    };

    if (motionDom.isMotionValue(subject)) {
      var subjectSequence = getSubjectSequence(subject, sequences);
      resolveValueSequence(keyframes, transition, getValueSequence("default", subjectSequence));
    } else {
      var subjects = resolveSubjects(subject, keyframes, scope, elementCache);
      var numSubjects = subjects.length;
      /**
       * For every element in this segment, process the defined values.
       */

      for (var subjectIndex = 0; subjectIndex < numSubjects; subjectIndex++) {
        /**
         * Cast necessary, but we know these are of this type
         */
        keyframes = keyframes;
        transition = transition;
        var thisSubject = subjects[subjectIndex];

        var _subjectSequence = getSubjectSequence(thisSubject, sequences);

        for (var key in keyframes) {
          resolveValueSequence(keyframes[key], getValueTransition(transition, key), getValueSequence(key, _subjectSequence), subjectIndex, numSubjects);
        }
      }
    }

    prevTime = currentTime;
    currentTime += maxDuration;
  };

  for (var i = 0; i < sequence.length; i++) {
    var _ret = _loop(i);

    if (_ret === "continue") continue;
  }
  /**
   * For every element and value combination create a new animation.
   */


  sequences.forEach(function (valueSequences, element) {
    for (var key in valueSequences) {
      var valueSequence = valueSequences[key];
      /**
       * Arrange all the keyframes in ascending time order.
       */

      valueSequence.sort(compareByTime);
      var keyframes = [];
      var valueOffset = [];
      var valueEasing = [];
      /**
       * For each keyframe, translate absolute times into
       * relative offsets based on the total duration of the timeline.
       */

      for (var _i = 0; _i < valueSequence.length; _i++) {
        var _valueSequence$_i = valueSequence[_i],
            at = _valueSequence$_i.at,
            value = _valueSequence$_i.value,
            easing = _valueSequence$_i.easing;
        keyframes.push(value);
        valueOffset.push(motionUtils.progress(0, totalDuration, at));
        valueEasing.push(easing || "easeOut");
      }
      /**
       * If the first keyframe doesn't land on offset: 0
       * provide one by duplicating the initial keyframe. This ensures
       * it snaps to the first keyframe when the animation starts.
       */


      if (valueOffset[0] !== 0) {
        valueOffset.unshift(0);
        keyframes.unshift(keyframes[0]);
        valueEasing.unshift(defaultSegmentEasing);
      }
      /**
       * If the last keyframe doesn't land on offset: 1
       * provide one with a null wildcard value. This will ensure it
       * stays static until the end of the animation.
       */


      if (valueOffset[valueOffset.length - 1] !== 1) {
        valueOffset.push(1);
        keyframes.push(null);
      }

      if (!animationDefinitions.has(element)) {
        animationDefinitions.set(element, {
          keyframes: {},
          transition: {}
        });
      }

      var definition = animationDefinitions.get(element);
      definition.keyframes[key] = keyframes;
      definition.transition[key] = _objectSpread(_objectSpread({}, defaultTransition), {}, {
        duration: totalDuration,
        ease: valueEasing,
        times: valueOffset
      }, sequenceTransition);
    }
  });
  return animationDefinitions;
}

function getSubjectSequence(subject, sequences) {
  !sequences.has(subject) && sequences.set(subject, {});
  return sequences.get(subject);
}

function getValueSequence(name, sequences) {
  if (!sequences[name]) sequences[name] = [];
  return sequences[name];
}

function keyframesAsList(keyframes) {
  return Array.isArray(keyframes) ? keyframes : [keyframes];
}

function getValueTransition(transition, key) {
  return transition && transition[key] ? _objectSpread(_objectSpread({}, transition), transition[key]) : _objectSpread({}, transition);
}

var isNumber = function isNumber(keyframe) {
  return typeof keyframe === "number";
};

var isNumberKeyframesArray = function isNumberKeyframesArray(keyframes) {
  return keyframes.every(isNumber);
};

var visualElementStore = new WeakMap();

var isKeyframesTarget = function isKeyframesTarget(v) {
  return Array.isArray(v);
};

function getValueState(visualElement) {
  var state = [{}, {}];
  visualElement === null || visualElement === void 0 ? void 0 : visualElement.values.forEach(function (value, key) {
    state[0][key] = value.get();
    state[1][key] = value.getVelocity();
  });
  return state;
}

function resolveVariantFromProps(props, definition, custom, visualElement) {
  /**
   * If the variant definition is a function, resolve.
   */
  if (typeof definition === "function") {
    var _getValueState = getValueState(visualElement),
        _getValueState2 = _slicedToArray(_getValueState, 2),
        current = _getValueState2[0],
        velocity = _getValueState2[1];

    definition = definition(custom !== undefined ? custom : props.custom, current, velocity);
  }
  /**
   * If the variant definition is a variant label, or
   * the function returned a variant label, resolve.
   */


  if (typeof definition === "string") {
    definition = props.variants && props.variants[definition];
  }
  /**
   * At this point we've resolved both functions and variant labels,
   * but the resolved variant label might itself have been a function.
   * If so, resolve. This can only have returned a valid target object.
   */


  if (typeof definition === "function") {
    var _getValueState3 = getValueState(visualElement),
        _getValueState4 = _slicedToArray(_getValueState3, 2),
        _current = _getValueState4[0],
        _velocity = _getValueState4[1];

    definition = definition(custom !== undefined ? custom : props.custom, _current, _velocity);
  }

  return definition;
}

function resolveVariant(visualElement, definition, custom) {
  var props = visualElement.getProps();
  return resolveVariantFromProps(props, definition, custom !== undefined ? custom : props.custom, visualElement);
}
/**
 * Set VisualElement's MotionValue, creating a new MotionValue for it if
 * it doesn't exist.
 */


function setMotionValue(visualElement, key, value) {
  if (visualElement.hasValue(key)) {
    visualElement.getValue(key).set(value);
  } else {
    visualElement.addValue(key, motionDom.motionValue(value));
  }
}

function resolveFinalValueInKeyframes(v) {
  // TODO maybe throw if v.length - 1 is placeholder token?
  return isKeyframesTarget(v) ? v[v.length - 1] || 0 : v;
}

function setTarget(visualElement, definition) {
  var resolved = resolveVariant(visualElement, definition);

  var _ref2 = resolved || {},
      _ref2$transitionEnd = _ref2.transitionEnd,
      transitionEnd = _ref2$transitionEnd === void 0 ? {} : _ref2$transitionEnd,
      _ref2$transition = _ref2.transition,
      transition = _ref2$transition === void 0 ? {} : _ref2$transition,
      target = _objectWithoutProperties(_ref2, ["transitionEnd", "transition"]);

  target = _objectSpread(_objectSpread({}, target), transitionEnd);

  for (var key in target) {
    var value = resolveFinalValueInKeyframes(target[key]);
    setMotionValue(visualElement, key, value);
  }
}

function isWillChangeMotionValue(value) {
  return Boolean(motionDom.isMotionValue(value) && value.add);
}

function addValueToWillChange(visualElement, key) {
  var willChange = visualElement.getValue("willChange");
  /**
   * It could be that a user has set willChange to a regular MotionValue,
   * in which case we can't add the value to it.
   */

  if (isWillChangeMotionValue(willChange)) {
    return willChange.add(key);
  } else if (!willChange && motionUtils.MotionGlobalConfig.WillChange) {
    var newWillChange = new motionUtils.MotionGlobalConfig.WillChange("auto");
    visualElement.addValue("willChange", newWillChange);
    newWillChange.add(key);
  }
}
/**
 * Convert camelCase to dash-case properties.
 */


var camelToDash = function camelToDash(str) {
  return str.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();
};

var optimizedAppearDataId = "framerAppearId";
var optimizedAppearDataAttribute = "data-" + camelToDash(optimizedAppearDataId);

function getOptimisedAppearId(visualElement) {
  return visualElement.props[optimizedAppearDataAttribute];
}

var isNotNull = function isNotNull(value) {
  return value !== null;
};

function getFinalKeyframe(keyframes, _ref3, finalKeyframe) {
  var repeat = _ref3.repeat,
      _ref3$repeatType = _ref3.repeatType,
      repeatType = _ref3$repeatType === void 0 ? "loop" : _ref3$repeatType;
  var resolvedKeyframes = keyframes.filter(isNotNull);
  var index = repeat && repeatType !== "loop" && repeat % 2 === 1 ? 0 : resolvedKeyframes.length - 1;
  return !index || finalKeyframe === undefined ? resolvedKeyframes[index] : finalKeyframe;
}

var underDampedSpring = {
  type: "spring",
  stiffness: 500,
  damping: 25,
  restSpeed: 10
};

var criticallyDampedSpring = function criticallyDampedSpring(target) {
  return {
    type: "spring",
    stiffness: 550,
    damping: target === 0 ? 2 * Math.sqrt(550) : 30,
    restSpeed: 10
  };
};

var keyframesTransition = {
  type: "keyframes",
  duration: 0.8
};
/**
 * Default easing curve is a slightly shallower version of
 * the default browser easing curve.
 */

var ease = {
  type: "keyframes",
  ease: [0.25, 0.1, 0.35, 1],
  duration: 0.3
};

var getDefaultTransition = function getDefaultTransition(valueKey, _ref4) {
  var keyframes = _ref4.keyframes;

  if (keyframes.length > 2) {
    return keyframesTransition;
  } else if (motionDom.transformProps.has(valueKey)) {
    return valueKey.startsWith("scale") ? criticallyDampedSpring(keyframes[1]) : underDampedSpring;
  }

  return ease;
};
/**
 * Decide whether a transition is defined on a given Transition.
 * This filters out orchestration options and returns true
 * if any options are left.
 */


function isTransitionDefined(_ref5) {
  var when = _ref5.when,
      _delay = _ref5.delay,
      delayChildren = _ref5.delayChildren,
      staggerChildren = _ref5.staggerChildren,
      staggerDirection = _ref5.staggerDirection,
      repeat = _ref5.repeat,
      repeatType = _ref5.repeatType,
      repeatDelay = _ref5.repeatDelay,
      from = _ref5.from,
      elapsed = _ref5.elapsed,
      transition = _objectWithoutProperties(_ref5, ["when", "delay", "delayChildren", "staggerChildren", "staggerDirection", "repeat", "repeatType", "repeatDelay", "from", "elapsed"]);

  return !!Object.keys(transition).length;
}

var animateMotionValue = function animateMotionValue(name, value, target) {
  var transition = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var element = arguments.length > 4 ? arguments[4] : undefined;
  var isHandoff = arguments.length > 5 ? arguments[5] : undefined;
  return function (_onComplete) {
    var valueTransition = motionDom.getValueTransition(transition, name) || {};
    /**
     * Most transition values are currently completely overwritten by value-specific
     * transitions. In the future it'd be nicer to blend these transitions. But for now
     * delay actually does inherit from the root transition if not value-specific.
     */

    var delay = valueTransition.delay || transition.delay || 0;
    /**
     * Elapsed isn't a public transition option but can be passed through from
     * optimized appear effects in milliseconds.
     */

    var _transition$elapsed = transition.elapsed,
        elapsed = _transition$elapsed === void 0 ? 0 : _transition$elapsed;
    elapsed = elapsed - motionUtils.secondsToMilliseconds(delay);

    var options = _objectSpread(_objectSpread({
      keyframes: Array.isArray(target) ? target : [null, target],
      ease: "easeOut",
      velocity: value.getVelocity()
    }, valueTransition), {}, {
      delay: -elapsed,
      onUpdate: function onUpdate(v) {
        value.set(v);
        valueTransition.onUpdate && valueTransition.onUpdate(v);
      },
      onComplete: function onComplete() {
        _onComplete();

        valueTransition.onComplete && valueTransition.onComplete();
      },
      name: name,
      motionValue: value,
      element: isHandoff ? undefined : element
    });
    /**
     * If there's no transition defined for this value, we can generate
     * unique transition settings for this value.
     */


    if (!isTransitionDefined(valueTransition)) {
      Object.assign(options, getDefaultTransition(name, options));
    }
    /**
     * Both WAAPI and our internal animation functions use durations
     * as defined by milliseconds, while our external API defines them
     * as seconds.
     */


    options.duration && (options.duration = motionUtils.secondsToMilliseconds(options.duration));
    options.repeatDelay && (options.repeatDelay = motionUtils.secondsToMilliseconds(options.repeatDelay));
    /**
     * Support deprecated way to set initial value. Prefer keyframe syntax.
     */

    if (options.from !== undefined) {
      options.keyframes[0] = options.from;
    }

    var shouldSkip = false;

    if (options.type === false || options.duration === 0 && !options.repeatDelay) {
      options.duration = 0;

      if (options.delay === 0) {
        shouldSkip = true;
      }
    }

    if (motionUtils.MotionGlobalConfig.instantAnimations || motionUtils.MotionGlobalConfig.skipAnimations) {
      shouldSkip = true;
      options.duration = 0;
      options.delay = 0;
    }
    /**
     * If the transition type or easing has been explicitly set by the user
     * then we don't want to allow flattening the animation.
     */


    options.allowFlatten = !valueTransition.type && !valueTransition.ease;
    /**
     * If we can or must skip creating the animation, and apply only
     * the final keyframe, do so. We also check once keyframes are resolved but
     * this early check prevents the need to create an animation at all.
     */

    if (shouldSkip && !isHandoff && value.get() !== undefined) {
      var finalKeyframe = getFinalKeyframe(options.keyframes, valueTransition);

      if (finalKeyframe !== undefined) {
        motionDom.frame.update(function () {
          options.onUpdate(finalKeyframe);
          options.onComplete();
        });
        return;
      }
    }

    return valueTransition.isSync ? new motionDom.JSAnimation(options) : new motionDom.AsyncMotionValueAnimation(options);
  };
};
/**
 * Decide whether we should block this animation. Previously, we achieved this
 * just by checking whether the key was listed in protectedKeys, but this
 * posed problems if an animation was triggered by afterChildren and protectedKeys
 * had been set to true in the meantime.
 */


function shouldBlockAnimation(_ref6, key) {
  var protectedKeys = _ref6.protectedKeys,
      needsAnimating = _ref6.needsAnimating;
  var shouldBlock = protectedKeys.hasOwnProperty(key) && needsAnimating[key] !== true;
  needsAnimating[key] = false;
  return shouldBlock;
}

function animateTarget(visualElement, targetAndTransition) {
  var _ref7 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      _ref7$delay = _ref7.delay,
      delay = _ref7$delay === void 0 ? 0 : _ref7$delay,
      transitionOverride = _ref7.transitionOverride,
      type = _ref7.type;

  var _targetAndTransition$ = targetAndTransition.transition,
      transition = _targetAndTransition$ === void 0 ? visualElement.getDefaultTransition() : _targetAndTransition$,
      transitionEnd = targetAndTransition.transitionEnd,
      target = _objectWithoutProperties(targetAndTransition, ["transition", "transitionEnd"]);

  if (transitionOverride) transition = transitionOverride;
  var animations = [];
  var animationTypeState = type && visualElement.animationState && visualElement.animationState.getState()[type];

  for (var key in target) {
    var _visualElement$latest;

    var value = visualElement.getValue(key, (_visualElement$latest = visualElement.latestValues[key]) !== null && _visualElement$latest !== void 0 ? _visualElement$latest : null);
    var valueTarget = target[key];

    if (valueTarget === undefined || animationTypeState && shouldBlockAnimation(animationTypeState, key)) {
      continue;
    }

    var valueTransition = _objectSpread({
      delay: delay
    }, motionDom.getValueTransition(transition || {}, key));
    /**
     * If the value is already at the defined target, skip the animation.
     */


    var currentValue = value.get();

    if (currentValue !== undefined && !value.isAnimating && !Array.isArray(valueTarget) && valueTarget === currentValue && !valueTransition.velocity) {
      continue;
    }
    /**
     * If this is the first time a value is being animated, check
     * to see if we're handling off from an existing animation.
     */


    var isHandoff = false;

    if (window.MotionHandoffAnimation) {
      var appearId = getOptimisedAppearId(visualElement);

      if (appearId) {
        var startTime = window.MotionHandoffAnimation(appearId, key, motionDom.frame);

        if (startTime !== null) {
          valueTransition.startTime = startTime;
          isHandoff = true;
        }
      }
    }

    addValueToWillChange(visualElement, key);
    value.start(animateMotionValue(key, value, valueTarget, visualElement.shouldReduceMotion && motionDom.positionalKeys.has(key) ? {
      type: false
    } : valueTransition, visualElement, isHandoff));
    var animation = value.animation;

    if (animation) {
      animations.push(animation);
    }
  }

  if (transitionEnd) {
    Promise.all(animations).then(function () {
      motionDom.frame.update(function () {
        transitionEnd && setTarget(visualElement, transitionEnd);
      });
    });
  }

  return animations;
}
/**
 * Bounding boxes tend to be defined as top, left, right, bottom. For various operations
 * it's easier to consider each axis individually. This function returns a bounding box
 * as a map of single-axis min/max values.
 */


function convertBoundingBoxToBox(_ref8) {
  var top = _ref8.top,
      left = _ref8.left,
      right = _ref8.right,
      bottom = _ref8.bottom;
  return {
    x: {
      min: left,
      max: right
    },
    y: {
      min: top,
      max: bottom
    }
  };
}
/**
 * Applies a TransformPoint function to a bounding box. TransformPoint is usually a function
 * provided by Framer to allow measured points to be corrected for device scaling. This is used
 * when measuring DOM elements and DOM event points.
 */


function transformBoxPoints(point, transformPoint) {
  if (!transformPoint) return point;
  var topLeft = transformPoint({
    x: point.left,
    y: point.top
  });
  var bottomRight = transformPoint({
    x: point.right,
    y: point.bottom
  });
  return {
    top: topLeft.y,
    left: topLeft.x,
    bottom: bottomRight.y,
    right: bottomRight.x
  };
}

function measureViewportBox(instance, transformPoint) {
  return convertBoundingBoxToBox(transformBoxPoints(instance.getBoundingClientRect(), transformPoint));
}

var featureProps = {
  animation: ["animate", "variants", "whileHover", "whileTap", "exit", "whileInView", "whileFocus", "whileDrag"],
  exit: ["exit"],
  drag: ["drag", "dragControls"],
  focus: ["whileFocus"],
  hover: ["whileHover", "onHoverStart", "onHoverEnd"],
  tap: ["whileTap", "onTap", "onTapStart", "onTapCancel"],
  pan: ["onPan", "onPanStart", "onPanSessionStart", "onPanEnd"],
  inView: ["whileInView", "onViewportEnter", "onViewportLeave"],
  layout: ["layout", "layoutId"]
};
var featureDefinitions = {};

var _loop2 = function _loop2(key) {
  featureDefinitions[key] = {
    isEnabled: function isEnabled(props) {
      return featureProps[key].some(function (name) {
        return !!props[name];
      });
    }
  };
};

for (var key in featureProps) {
  _loop2(key);
}

var createAxis = function createAxis() {
  return {
    min: 0,
    max: 0
  };
};

var createBox = function createBox() {
  return {
    x: createAxis(),
    y: createAxis()
  };
};

var isBrowser = typeof window !== "undefined"; // Does this device prefer reduced motion? Returns `null` server-side.

var prefersReducedMotion = {
  current: null
};
var hasReducedMotionListener = {
  current: false
};

function initPrefersReducedMotion() {
  hasReducedMotionListener.current = true;
  if (!isBrowser) return;

  if (window.matchMedia) {
    var motionMediaQuery = window.matchMedia("(prefers-reduced-motion)");

    var setReducedMotionPreferences = function setReducedMotionPreferences() {
      return prefersReducedMotion.current = motionMediaQuery.matches;
    };

    motionMediaQuery.addListener(setReducedMotionPreferences);
    setReducedMotionPreferences();
  } else {
    prefersReducedMotion.current = false;
  }
}

function isAnimationControls(v) {
  return v !== null && _typeof(v) === "object" && typeof v.start === "function";
}
/**
 * Decides if the supplied variable is variant label
 */


function isVariantLabel(v) {
  return typeof v === "string" || Array.isArray(v);
}

var variantPriorityOrder = ["animate", "whileInView", "whileFocus", "whileHover", "whileTap", "whileDrag", "exit"];
var variantProps = ["initial"].concat(variantPriorityOrder);

function isControllingVariants(props) {
  return isAnimationControls(props.animate) || variantProps.some(function (name) {
    return isVariantLabel(props[name]);
  });
}

function isVariantNode(props) {
  return Boolean(isControllingVariants(props) || props.variants);
}

function updateMotionValuesFromProps(element, next, prev) {
  for (var _key in next) {
    var nextValue = next[_key];
    var prevValue = prev[_key];

    if (motionDom.isMotionValue(nextValue)) {
      /**
       * If this is a motion value found in props or style, we want to add it
       * to our visual element's motion value map.
       */
      element.addValue(_key, nextValue);
    } else if (motionDom.isMotionValue(prevValue)) {
      /**
       * If we're swapping from a motion value to a static value,
       * create a new motion value from that
       */
      element.addValue(_key, motionDom.motionValue(nextValue, {
        owner: element
      }));
    } else if (prevValue !== nextValue) {
      /**
       * If this is a flat value that has changed, update the motion value
       * or create one if it doesn't exist. We only want to do this if we're
       * not handling the value with our animation state.
       */
      if (element.hasValue(_key)) {
        var existingValue = element.getValue(_key);

        if (existingValue.liveStyle === true) {
          existingValue.jump(nextValue);
        } else if (!existingValue.hasAnimated) {
          existingValue.set(nextValue);
        }
      } else {
        var latestValue = element.getStaticValue(_key);
        element.addValue(_key, motionDom.motionValue(latestValue !== undefined ? latestValue : nextValue, {
          owner: element
        }));
      }
    }
  } // Handle removed values


  for (var _key2 in prev) {
    if (next[_key2] === undefined) element.removeValue(_key2);
  }

  return next;
}

var propEventHandlers = ["AnimationStart", "AnimationComplete", "Update", "BeforeLayoutMeasure", "LayoutMeasure", "LayoutAnimationStart", "LayoutAnimationComplete"];
/**
 * A VisualElement is an imperative abstraction around UI elements such as
 * HTMLElement, SVGElement, Three.Object3D etc.
 */

var VisualElement = /*#__PURE__*/function () {
  function VisualElement(_ref9) {
    var _this = this;

    var parent = _ref9.parent,
        props = _ref9.props,
        presenceContext = _ref9.presenceContext,
        reducedMotionConfig = _ref9.reducedMotionConfig,
        blockInitialAnimation = _ref9.blockInitialAnimation,
        visualState = _ref9.visualState;
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, VisualElement);

    /**
     * A reference to the current underlying Instance, e.g. a HTMLElement
     * or Three.Mesh etc.
     */
    this.current = null;
    /**
     * A set containing references to this VisualElement's children.
     */

    this.children = new Set();
    /**
     * Determine what role this visual element should take in the variant tree.
     */

    this.isVariantNode = false;
    this.isControllingVariants = false;
    /**
     * Decides whether this VisualElement should animate in reduced motion
     * mode.
     *
     * TODO: This is currently set on every individual VisualElement but feels
     * like it could be set globally.
     */

    this.shouldReduceMotion = null;
    /**
     * A map of all motion values attached to this visual element. Motion
     * values are source of truth for any given animated value. A motion
     * value might be provided externally by the component via props.
     */

    this.values = new Map();
    this.KeyframeResolver = motionDom.KeyframeResolver;
    /**
     * Cleanup functions for active features (hover/tap/exit etc)
     */

    this.features = {};
    /**
     * A map of every subscription that binds the provided or generated
     * motion values onChange listeners to this visual element.
     */

    this.valueSubscriptions = new Map();
    /**
     * A reference to the previously-provided motion values as returned
     * from scrapeMotionValuesFromProps. We use the keys in here to determine
     * if any motion values need to be removed after props are updated.
     */

    this.prevMotionValues = {};
    /**
     * An object containing a SubscriptionManager for each active event.
     */

    this.events = {};
    /**
     * An object containing an unsubscribe function for each prop event subscription.
     * For example, every "Update" event can have multiple subscribers via
     * VisualElement.on(), but only one of those can be defined via the onUpdate prop.
     */

    this.propEventSubscriptions = {};

    this.notifyUpdate = function () {
      return _this.notify("Update", _this.latestValues);
    };

    this.render = function () {
      if (!_this.current) return;

      _this.triggerBuild();

      _this.renderInstance(_this.current, _this.renderState, _this.props.style, _this.projection);
    };

    this.renderScheduledAt = 0.0;

    this.scheduleRender = function () {
      var now = motionDom.time.now();

      if (_this.renderScheduledAt < now) {
        _this.renderScheduledAt = now;
        motionDom.frame.render(_this.render, false, true);
      }
    };

    var latestValues = visualState.latestValues,
        renderState = visualState.renderState;
    this.latestValues = latestValues;
    this.baseTarget = _objectSpread({}, latestValues);
    this.initialValues = props.initial ? _objectSpread({}, latestValues) : {};
    this.renderState = renderState;
    this.parent = parent;
    this.props = props;
    this.presenceContext = presenceContext;
    this.depth = parent ? parent.depth + 1 : 0;
    this.reducedMotionConfig = reducedMotionConfig;
    this.options = options;
    this.blockInitialAnimation = Boolean(blockInitialAnimation);
    this.isControllingVariants = isControllingVariants(props);
    this.isVariantNode = isVariantNode(props);

    if (this.isVariantNode) {
      this.variantChildren = new Set();
    }

    this.manuallyAnimateOnMount = Boolean(parent && parent.current);
    /**
     * Any motion values that are provided to the element when created
     * aren't yet bound to the element, as this would technically be impure.
     * However, we iterate through the motion values and set them to the
     * initial values for this component.
     *
     * TODO: This is impure and we should look at changing this to run on mount.
     * Doing so will break some tests but this isn't necessarily a breaking change,
     * more a reflection of the test.
     */

    var _this$scrapeMotionVal = this.scrapeMotionValuesFromProps(props, {}, this),
        willChange = _this$scrapeMotionVal.willChange,
        initialMotionValues = _objectWithoutProperties(_this$scrapeMotionVal, ["willChange"]);

    for (var _key3 in initialMotionValues) {
      var value = initialMotionValues[_key3];

      if (latestValues[_key3] !== undefined && motionDom.isMotionValue(value)) {
        value.set(latestValues[_key3], false);
      }
    }
  }

  _createClass(VisualElement, [{
    key: "scrapeMotionValuesFromProps",
    value:
    /**
     * This method takes React props and returns found MotionValues. For example, HTML
     * MotionValues will be found within the style prop, whereas for Three.js within attribute arrays.
     *
     * This isn't an abstract method as it needs calling in the constructor, but it is
     * intended to be one.
     */
    function scrapeMotionValuesFromProps(_props, _prevProps, _visualElement) {
      return {};
    }
  }, {
    key: "mount",
    value: function mount(instance) {
      var _this2 = this;

      this.current = instance;
      visualElementStore.set(instance, this);

      if (this.projection && !this.projection.instance) {
        this.projection.mount(instance);
      }

      if (this.parent && this.isVariantNode && !this.isControllingVariants) {
        this.removeFromVariantTree = this.parent.addVariantChild(this);
      }

      this.values.forEach(function (value, key) {
        return _this2.bindToMotionValue(key, value);
      });

      if (!hasReducedMotionListener.current) {
        initPrefersReducedMotion();
      }

      this.shouldReduceMotion = this.reducedMotionConfig === "never" ? false : this.reducedMotionConfig === "always" ? true : prefersReducedMotion.current;

      if (process.env.NODE_ENV !== "production") {
        motionUtils.warnOnce(this.shouldReduceMotion !== true, "You have Reduced Motion enabled on your device. Animations may not appear as expected.");
      }

      if (this.parent) this.parent.children.add(this);
      this.update(this.props, this.presenceContext);
    }
  }, {
    key: "unmount",
    value: function unmount() {
      this.projection && this.projection.unmount();
      motionDom.cancelFrame(this.notifyUpdate);
      motionDom.cancelFrame(this.render);
      this.valueSubscriptions.forEach(function (remove) {
        return remove();
      });
      this.valueSubscriptions.clear();
      this.removeFromVariantTree && this.removeFromVariantTree();
      this.parent && this.parent.children.delete(this);

      for (var _key4 in this.events) {
        this.events[_key4].clear();
      }

      for (var _key5 in this.features) {
        var feature = this.features[_key5];

        if (feature) {
          feature.unmount();
          feature.isMounted = false;
        }
      }

      this.current = null;
    }
  }, {
    key: "bindToMotionValue",
    value: function bindToMotionValue(key, value) {
      var _this3 = this;

      if (this.valueSubscriptions.has(key)) {
        this.valueSubscriptions.get(key)();
      }

      var valueIsTransform = motionDom.transformProps.has(key);

      if (valueIsTransform && this.onBindTransform) {
        this.onBindTransform();
      }

      var removeOnChange = value.on("change", function (latestValue) {
        _this3.latestValues[key] = latestValue;
        _this3.props.onUpdate && motionDom.frame.preRender(_this3.notifyUpdate);

        if (valueIsTransform && _this3.projection) {
          _this3.projection.isTransformDirty = true;
        }
      });
      var removeOnRenderRequest = value.on("renderRequest", this.scheduleRender);
      var removeSyncCheck;

      if (window.MotionCheckAppearSync) {
        removeSyncCheck = window.MotionCheckAppearSync(this, key, value);
      }

      this.valueSubscriptions.set(key, function () {
        removeOnChange();
        removeOnRenderRequest();
        if (removeSyncCheck) removeSyncCheck();
        if (value.owner) value.stop();
      });
    }
  }, {
    key: "sortNodePosition",
    value: function sortNodePosition(other) {
      /**
       * If these nodes aren't even of the same type we can't compare their depth.
       */
      if (!this.current || !this.sortInstanceNodePosition || this.type !== other.type) {
        return 0;
      }

      return this.sortInstanceNodePosition(this.current, other.current);
    }
  }, {
    key: "updateFeatures",
    value: function updateFeatures() {
      var key = "animation";

      for (key in featureDefinitions) {
        var featureDefinition = featureDefinitions[key];
        if (!featureDefinition) continue;
        var isEnabled = featureDefinition.isEnabled,
            FeatureConstructor = featureDefinition.Feature;
        /**
         * If this feature is enabled but not active, make a new instance.
         */

        if (!this.features[key] && FeatureConstructor && isEnabled(this.props)) {
          this.features[key] = new FeatureConstructor(this);
        }
        /**
         * If we have a feature, mount or update it.
         */


        if (this.features[key]) {
          var feature = this.features[key];

          if (feature.isMounted) {
            feature.update();
          } else {
            feature.mount();
            feature.isMounted = true;
          }
        }
      }
    }
  }, {
    key: "triggerBuild",
    value: function triggerBuild() {
      this.build(this.renderState, this.latestValues, this.props);
    }
    /**
     * Measure the current viewport box with or without transforms.
     * Only measures axis-aligned boxes, rotate and skew must be manually
     * removed with a re-render to work.
     */

  }, {
    key: "measureViewportBox",
    value: function measureViewportBox() {
      return this.current ? this.measureInstanceViewportBox(this.current, this.props) : createBox();
    }
  }, {
    key: "getStaticValue",
    value: function getStaticValue(key) {
      return this.latestValues[key];
    }
  }, {
    key: "setStaticValue",
    value: function setStaticValue(key, value) {
      this.latestValues[key] = value;
    }
    /**
     * Update the provided props. Ensure any newly-added motion values are
     * added to our map, old ones removed, and listeners updated.
     */

  }, {
    key: "update",
    value: function update(props, presenceContext) {
      if (props.transformTemplate || this.props.transformTemplate) {
        this.scheduleRender();
      }

      this.prevProps = this.props;
      this.props = props;
      this.prevPresenceContext = this.presenceContext;
      this.presenceContext = presenceContext;
      /**
       * Update prop event handlers ie onAnimationStart, onAnimationComplete
       */

      for (var i = 0; i < propEventHandlers.length; i++) {
        var _key6 = propEventHandlers[i];

        if (this.propEventSubscriptions[_key6]) {
          this.propEventSubscriptions[_key6]();

          delete this.propEventSubscriptions[_key6];
        }

        var listenerName = "on" + _key6;
        var listener = props[listenerName];

        if (listener) {
          this.propEventSubscriptions[_key6] = this.on(_key6, listener);
        }
      }

      this.prevMotionValues = updateMotionValuesFromProps(this, this.scrapeMotionValuesFromProps(props, this.prevProps, this), this.prevMotionValues);

      if (this.handleChildMotionValue) {
        this.handleChildMotionValue();
      }
    }
  }, {
    key: "getProps",
    value: function getProps() {
      return this.props;
    }
    /**
     * Returns the variant definition with a given name.
     */

  }, {
    key: "getVariant",
    value: function getVariant(name) {
      return this.props.variants ? this.props.variants[name] : undefined;
    }
    /**
     * Returns the defined default transition on this component.
     */

  }, {
    key: "getDefaultTransition",
    value: function getDefaultTransition() {
      return this.props.transition;
    }
  }, {
    key: "getTransformPagePoint",
    value: function getTransformPagePoint() {
      return this.props.transformPagePoint;
    }
  }, {
    key: "getClosestVariantNode",
    value: function getClosestVariantNode() {
      return this.isVariantNode ? this : this.parent ? this.parent.getClosestVariantNode() : undefined;
    }
    /**
     * Add a child visual element to our set of children.
     */

  }, {
    key: "addVariantChild",
    value: function addVariantChild(child) {
      var closestVariantNode = this.getClosestVariantNode();

      if (closestVariantNode) {
        closestVariantNode.variantChildren && closestVariantNode.variantChildren.add(child);
        return function () {
          return closestVariantNode.variantChildren.delete(child);
        };
      }
    }
    /**
     * Add a motion value and bind it to this visual element.
     */

  }, {
    key: "addValue",
    value: function addValue(key, value) {
      // Remove existing value if it exists
      var existingValue = this.values.get(key);

      if (value !== existingValue) {
        if (existingValue) this.removeValue(key);
        this.bindToMotionValue(key, value);
        this.values.set(key, value);
        this.latestValues[key] = value.get();
      }
    }
    /**
     * Remove a motion value and unbind any active subscriptions.
     */

  }, {
    key: "removeValue",
    value: function removeValue(key) {
      this.values.delete(key);
      var unsubscribe = this.valueSubscriptions.get(key);

      if (unsubscribe) {
        unsubscribe();
        this.valueSubscriptions.delete(key);
      }

      delete this.latestValues[key];
      this.removeValueFromRenderState(key, this.renderState);
    }
    /**
     * Check whether we have a motion value for this key
     */

  }, {
    key: "hasValue",
    value: function hasValue(key) {
      return this.values.has(key);
    }
  }, {
    key: "getValue",
    value: function getValue(key, defaultValue) {
      if (this.props.values && this.props.values[key]) {
        return this.props.values[key];
      }

      var value = this.values.get(key);

      if (value === undefined && defaultValue !== undefined) {
        value = motionDom.motionValue(defaultValue === null ? undefined : defaultValue, {
          owner: this
        });
        this.addValue(key, value);
      }

      return value;
    }
    /**
     * If we're trying to animate to a previously unencountered value,
     * we need to check for it in our state and as a last resort read it
     * directly from the instance (which might have performance implications).
     */

  }, {
    key: "readValue",
    value: function readValue(key, target) {
      var _this$getBaseTargetFr;

      var value = this.latestValues[key] !== undefined || !this.current ? this.latestValues[key] : (_this$getBaseTargetFr = this.getBaseTargetFromProps(this.props, key)) !== null && _this$getBaseTargetFr !== void 0 ? _this$getBaseTargetFr : this.readValueFromInstance(this.current, key, this.options);

      if (value !== undefined && value !== null) {
        if (typeof value === "string" && (motionUtils.isNumericalString(value) || motionUtils.isZeroValueString(value))) {
          // If this is a number read as a string, ie "0" or "200", convert it to a number
          value = parseFloat(value);
        } else if (!motionDom.findValueType(value) && motionDom.complex.test(target)) {
          value = motionDom.getAnimatableNone(key, target);
        }

        this.setBaseTarget(key, motionDom.isMotionValue(value) ? value.get() : value);
      }

      return motionDom.isMotionValue(value) ? value.get() : value;
    }
    /**
     * Set the base target to later animate back to. This is currently
     * only hydrated on creation and when we first read a value.
     */

  }, {
    key: "setBaseTarget",
    value: function setBaseTarget(key, value) {
      this.baseTarget[key] = value;
    }
    /**
     * Find the base target for a value thats been removed from all animation
     * props.
     */

  }, {
    key: "getBaseTarget",
    value: function getBaseTarget(key) {
      var initial = this.props.initial;
      var valueFromInitial;

      if (typeof initial === "string" || _typeof(initial) === "object") {
        var _this$presenceContext;

        var variant = resolveVariantFromProps(this.props, initial, (_this$presenceContext = this.presenceContext) === null || _this$presenceContext === void 0 ? void 0 : _this$presenceContext.custom);

        if (variant) {
          valueFromInitial = variant[key];
        }
      }
      /**
       * If this value still exists in the current initial variant, read that.
       */


      if (initial && valueFromInitial !== undefined) {
        return valueFromInitial;
      }
      /**
       * Alternatively, if this VisualElement config has defined a getBaseTarget
       * so we can read the value from an alternative source, try that.
       */


      var target = this.getBaseTargetFromProps(this.props, key);
      if (target !== undefined && !motionDom.isMotionValue(target)) return target;
      /**
       * If the value was initially defined on initial, but it doesn't any more,
       * return undefined. Otherwise return the value as initially read from the DOM.
       */

      return this.initialValues[key] !== undefined && valueFromInitial === undefined ? undefined : this.baseTarget[key];
    }
  }, {
    key: "on",
    value: function on(eventName, callback) {
      if (!this.events[eventName]) {
        this.events[eventName] = new motionUtils.SubscriptionManager();
      }

      return this.events[eventName].add(callback);
    }
  }, {
    key: "notify",
    value: function notify(eventName) {
      if (this.events[eventName]) {
        var _this$events$eventNam;

        for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key7 = 1; _key7 < _len; _key7++) {
          args[_key7 - 1] = arguments[_key7];
        }

        (_this$events$eventNam = this.events[eventName]).notify.apply(_this$events$eventNam, args);
      }
    }
  }]);

  return VisualElement;
}();

var DOMVisualElement = /*#__PURE__*/function (_VisualElement) {
  _inherits(DOMVisualElement, _VisualElement);

  var _super = _createSuper(DOMVisualElement);

  function DOMVisualElement() {
    var _this4;

    _classCallCheck(this, DOMVisualElement);

    _this4 = _super.apply(this, arguments);
    _this4.KeyframeResolver = motionDom.DOMKeyframesResolver;
    return _this4;
  }

  _createClass(DOMVisualElement, [{
    key: "sortInstanceNodePosition",
    value: function sortInstanceNodePosition(a, b) {
      /**
       * compareDocumentPosition returns a bitmask, by using the bitwise &
       * we're returning true if 2 in that bitmask is set to true. 2 is set
       * to true if b preceeds a.
       */
      return a.compareDocumentPosition(b) & 2 ? 1 : -1;
    }
  }, {
    key: "getBaseTargetFromProps",
    value: function getBaseTargetFromProps(props, key) {
      return props.style ? props.style[key] : undefined;
    }
  }, {
    key: "removeValueFromRenderState",
    value: function removeValueFromRenderState(key, _ref10) {
      var vars = _ref10.vars,
          style = _ref10.style;
      delete vars[key];
      delete style[key];
    }
  }, {
    key: "handleChildMotionValue",
    value: function handleChildMotionValue() {
      var _this5 = this;

      if (this.childSubscription) {
        this.childSubscription();
        delete this.childSubscription;
      }

      var children = this.props.children;

      if (motionDom.isMotionValue(children)) {
        this.childSubscription = children.on("change", function (latest) {
          if (_this5.current) {
            _this5.current.textContent = "".concat(latest);
          }
        });
      }
    }
  }]);

  return DOMVisualElement;
}(VisualElement);

var translateAlias = {
  x: "translateX",
  y: "translateY",
  z: "translateZ",
  transformPerspective: "perspective"
};
var numTransforms = motionDom.transformPropOrder.length;
/**
 * Build a CSS transform style from individual x/y/scale etc properties.
 *
 * This outputs with a default order of transforms/scales/rotations, this can be customised by
 * providing a transformTemplate function.
 */

function buildTransform(latestValues, transform, transformTemplate) {
  // The transform string we're going to build into.
  var transformString = "";
  var transformIsDefault = true;
  /**
   * Loop over all possible transforms in order, adding the ones that
   * are present to the transform string.
   */

  for (var i = 0; i < numTransforms; i++) {
    var _key8 = motionDom.transformPropOrder[i];
    var value = latestValues[_key8];
    if (value === undefined) continue;
    var valueIsDefault = true;

    if (typeof value === "number") {
      valueIsDefault = value === (_key8.startsWith("scale") ? 1 : 0);
    } else {
      valueIsDefault = parseFloat(value) === 0;
    }

    if (!valueIsDefault || transformTemplate) {
      var valueAsType = motionDom.getValueAsType(value, motionDom.numberValueTypes[_key8]);

      if (!valueIsDefault) {
        transformIsDefault = false;
        var transformName = translateAlias[_key8] || _key8;
        transformString += "".concat(transformName, "(").concat(valueAsType, ") ");
      }

      if (transformTemplate) {
        transform[_key8] = valueAsType;
      }
    }
  }

  transformString = transformString.trim(); // If we have a custom `transform` template, pass our transform values and
  // generated transformString to that before returning

  if (transformTemplate) {
    transformString = transformTemplate(transform, transformIsDefault ? "" : transformString);
  } else if (transformIsDefault) {
    transformString = "none";
  }

  return transformString;
}

function buildHTMLStyles(state, latestValues, transformTemplate) {
  var style = state.style,
      vars = state.vars,
      transformOrigin = state.transformOrigin; // Track whether we encounter any transform or transformOrigin values.

  var hasTransform = false;
  var hasTransformOrigin = false;
  /**
   * Loop over all our latest animated values and decide whether to handle them
   * as a style or CSS variable.
   *
   * Transforms and transform origins are kept separately for further processing.
   */

  for (var _key9 in latestValues) {
    var value = latestValues[_key9];

    if (motionDom.transformProps.has(_key9)) {
      // If this is a transform, flag to enable further transform processing
      hasTransform = true;
      continue;
    } else if (motionDom.isCSSVariableName(_key9)) {
      vars[_key9] = value;
      continue;
    } else {
      // Convert the value to its default value type, ie 0 -> "0px"
      var valueAsType = motionDom.getValueAsType(value, motionDom.numberValueTypes[_key9]);

      if (_key9.startsWith("origin")) {
        // If this is a transform origin, flag and enable further transform-origin processing
        hasTransformOrigin = true;
        transformOrigin[_key9] = valueAsType;
      } else {
        style[_key9] = valueAsType;
      }
    }
  }

  if (!latestValues.transform) {
    if (hasTransform || transformTemplate) {
      style.transform = buildTransform(latestValues, state.transform, transformTemplate);
    } else if (style.transform) {
      /**
       * If we have previously created a transform but currently don't have any,
       * reset transform style to none.
       */
      style.transform = "none";
    }
  }
  /**
   * Build a transformOrigin style. Uses the same defaults as the browser for
   * undefined origins.
   */


  if (hasTransformOrigin) {
    var _transformOrigin$orig = transformOrigin.originX,
        originX = _transformOrigin$orig === void 0 ? "50%" : _transformOrigin$orig,
        _transformOrigin$orig2 = transformOrigin.originY,
        originY = _transformOrigin$orig2 === void 0 ? "50%" : _transformOrigin$orig2,
        _transformOrigin$orig3 = transformOrigin.originZ,
        originZ = _transformOrigin$orig3 === void 0 ? 0 : _transformOrigin$orig3;
    style.transformOrigin = "".concat(originX, " ").concat(originY, " ").concat(originZ);
  }
}

function renderHTML(element, _ref11, styleProp, projection) {
  var style = _ref11.style,
      vars = _ref11.vars;
  Object.assign(element.style, style, projection && projection.getProjectionStyles(styleProp)); // Loop over any CSS variables and assign those.

  for (var _key10 in vars) {
    element.style.setProperty(_key10, vars[_key10]);
  }
}

var scaleCorrectors = {};

function isForcedMotionValue(key, _ref12) {
  var layout = _ref12.layout,
      layoutId = _ref12.layoutId;
  return motionDom.transformProps.has(key) || key.startsWith("origin") || (layout || layoutId !== undefined) && (!!scaleCorrectors[key] || key === "opacity");
}

function scrapeMotionValuesFromProps$1(props, prevProps, visualElement) {
  var style = props.style;
  var newValues = {};

  for (var _key11 in style) {
    var _visualElement$getVal;

    if (motionDom.isMotionValue(style[_key11]) || prevProps.style && motionDom.isMotionValue(prevProps.style[_key11]) || isForcedMotionValue(_key11, props) || (visualElement === null || visualElement === void 0 ? void 0 : (_visualElement$getVal = visualElement.getValue(_key11)) === null || _visualElement$getVal === void 0 ? void 0 : _visualElement$getVal.liveStyle) !== undefined) {
      newValues[_key11] = style[_key11];
    }
  }

  return newValues;
}

function getComputedStyle$1(element) {
  return window.getComputedStyle(element);
}

var HTMLVisualElement = /*#__PURE__*/function (_DOMVisualElement) {
  _inherits(HTMLVisualElement, _DOMVisualElement);

  var _super2 = _createSuper(HTMLVisualElement);

  function HTMLVisualElement() {
    var _this6;

    _classCallCheck(this, HTMLVisualElement);

    _this6 = _super2.apply(this, arguments);
    _this6.type = "html";
    _this6.renderInstance = renderHTML;
    return _this6;
  }

  _createClass(HTMLVisualElement, [{
    key: "readValueFromInstance",
    value: function readValueFromInstance(instance, key) {
      if (motionDom.transformProps.has(key)) {
        var _this$projection;

        return (_this$projection = this.projection) !== null && _this$projection !== void 0 && _this$projection.isProjecting ? motionDom.defaultTransformValue(key) : motionDom.readTransformValue(instance, key);
      } else {
        var computedStyle = getComputedStyle$1(instance);
        var value = (motionDom.isCSSVariableName(key) ? computedStyle.getPropertyValue(key) : computedStyle[key]) || 0;
        return typeof value === "string" ? value.trim() : value;
      }
    }
  }, {
    key: "measureInstanceViewportBox",
    value: function measureInstanceViewportBox(instance, _ref13) {
      var transformPagePoint = _ref13.transformPagePoint;
      return measureViewportBox(instance, transformPagePoint);
    }
  }, {
    key: "build",
    value: function build(renderState, latestValues, props) {
      buildHTMLStyles(renderState, latestValues, props.transformTemplate);
    }
  }, {
    key: "scrapeMotionValuesFromProps",
    value: function scrapeMotionValuesFromProps(props, prevProps, visualElement) {
      return scrapeMotionValuesFromProps$1(props, prevProps, visualElement);
    }
  }]);

  return HTMLVisualElement;
}(DOMVisualElement);

function isObjectKey(key, object) {
  return key in object;
}

var ObjectVisualElement = /*#__PURE__*/function (_VisualElement2) {
  _inherits(ObjectVisualElement, _VisualElement2);

  var _super3 = _createSuper(ObjectVisualElement);

  function ObjectVisualElement() {
    var _this7;

    _classCallCheck(this, ObjectVisualElement);

    _this7 = _super3.apply(this, arguments);
    _this7.type = "object";
    return _this7;
  }

  _createClass(ObjectVisualElement, [{
    key: "readValueFromInstance",
    value: function readValueFromInstance(instance, key) {
      if (isObjectKey(key, instance)) {
        var value = instance[key];

        if (typeof value === "string" || typeof value === "number") {
          return value;
        }
      }

      return undefined;
    }
  }, {
    key: "getBaseTargetFromProps",
    value: function getBaseTargetFromProps() {
      return undefined;
    }
  }, {
    key: "removeValueFromRenderState",
    value: function removeValueFromRenderState(key, renderState) {
      delete renderState.output[key];
    }
  }, {
    key: "measureInstanceViewportBox",
    value: function measureInstanceViewportBox() {
      return createBox();
    }
  }, {
    key: "build",
    value: function build(renderState, latestValues) {
      Object.assign(renderState.output, latestValues);
    }
  }, {
    key: "renderInstance",
    value: function renderInstance(instance, _ref14) {
      var output = _ref14.output;
      Object.assign(instance, output);
    }
  }, {
    key: "sortInstanceNodePosition",
    value: function sortInstanceNodePosition() {
      return 0;
    }
  }]);

  return ObjectVisualElement;
}(VisualElement);

var dashKeys = {
  offset: "stroke-dashoffset",
  array: "stroke-dasharray"
};
var camelKeys = {
  offset: "strokeDashoffset",
  array: "strokeDasharray"
};
/**
 * Build SVG path properties. Uses the path's measured length to convert
 * our custom pathLength, pathSpacing and pathOffset into stroke-dashoffset
 * and stroke-dasharray attributes.
 *
 * This function is mutative to reduce per-frame GC.
 */

function buildSVGPath(attrs, length) {
  var spacing = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
  var offset = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
  var useDashCase = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;
  // Normalise path length by setting SVG attribute pathLength to 1
  attrs.pathLength = 1; // We use dash case when setting attributes directly to the DOM node and camel case
  // when defining props on a React component.

  var keys = useDashCase ? dashKeys : camelKeys; // Build the dash offset

  attrs[keys.offset] = motionDom.px.transform(-offset); // Build the dash array

  var pathLength = motionDom.px.transform(length);
  var pathSpacing = motionDom.px.transform(spacing);
  attrs[keys.array] = "".concat(pathLength, " ").concat(pathSpacing);
}
/**
 * Build SVG visual attributes, like cx and style.transform
 */


function buildSVGAttrs(state, _ref15, isSVGTag, transformTemplate, styleProp) {
  var attrX = _ref15.attrX,
      attrY = _ref15.attrY,
      attrScale = _ref15.attrScale,
      pathLength = _ref15.pathLength,
      _ref15$pathSpacing = _ref15.pathSpacing,
      pathSpacing = _ref15$pathSpacing === void 0 ? 1 : _ref15$pathSpacing,
      _ref15$pathOffset = _ref15.pathOffset,
      pathOffset = _ref15$pathOffset === void 0 ? 0 : _ref15$pathOffset,
      latest = _objectWithoutProperties(_ref15, ["attrX", "attrY", "attrScale", "pathLength", "pathSpacing", "pathOffset"]);

  buildHTMLStyles(state, latest, transformTemplate);
  /**
   * For svg tags we just want to make sure viewBox is animatable and treat all the styles
   * as normal HTML tags.
   */

  if (isSVGTag) {
    if (state.style.viewBox) {
      state.attrs.viewBox = state.style.viewBox;
    }

    return;
  }

  state.attrs = state.style;
  state.style = {};
  var attrs = state.attrs,
      style = state.style;
  /**
   * However, we apply transforms as CSS transforms.
   * So if we detect a transform, transformOrigin we take it from attrs and copy it into style.
   */

  if (attrs.transform) {
    style.transform = attrs.transform;
    delete attrs.transform;
  }

  if (style.transform || attrs.transformOrigin) {
    var _attrs$transformOrigi;

    style.transformOrigin = (_attrs$transformOrigi = attrs.transformOrigin) !== null && _attrs$transformOrigi !== void 0 ? _attrs$transformOrigi : "50% 50%";
    delete attrs.transformOrigin;
  }

  if (style.transform) {
    var _styleProp$transformB;

    /**
     * SVG's element transform-origin uses its own median as a reference.
     * Therefore, transformBox becomes a fill-box
     */
    style.transformBox = (_styleProp$transformB = styleProp === null || styleProp === void 0 ? void 0 : styleProp.transformBox) !== null && _styleProp$transformB !== void 0 ? _styleProp$transformB : "fill-box";
    delete attrs.transformBox;
  } // Render attrX/attrY/attrScale as attributes


  if (attrX !== undefined) attrs.x = attrX;
  if (attrY !== undefined) attrs.y = attrY;
  if (attrScale !== undefined) attrs.scale = attrScale; // Build SVG path if one has been defined

  if (pathLength !== undefined) {
    buildSVGPath(attrs, pathLength, pathSpacing, pathOffset, false);
  }
}
/**
 * A set of attribute names that are always read/written as camel case.
 */


var camelCaseAttributes = new Set(["baseFrequency", "diffuseConstant", "kernelMatrix", "kernelUnitLength", "keySplines", "keyTimes", "limitingConeAngle", "markerHeight", "markerWidth", "numOctaves", "targetX", "targetY", "surfaceScale", "specularConstant", "specularExponent", "stdDeviation", "tableValues", "viewBox", "gradientTransform", "pathLength", "startOffset", "textLength", "lengthAdjust"]);

var isSVGTag = function isSVGTag(tag) {
  return typeof tag === "string" && tag.toLowerCase() === "svg";
};

function renderSVG(element, renderState, _styleProp, projection) {
  renderHTML(element, renderState, undefined, projection);

  for (var _key12 in renderState.attrs) {
    element.setAttribute(!camelCaseAttributes.has(_key12) ? camelToDash(_key12) : _key12, renderState.attrs[_key12]);
  }
}

function _scrapeMotionValuesFromProps(props, prevProps, visualElement) {
  var newValues = scrapeMotionValuesFromProps$1(props, prevProps, visualElement);

  for (var _key13 in props) {
    if (motionDom.isMotionValue(props[_key13]) || motionDom.isMotionValue(prevProps[_key13])) {
      var targetKey = motionDom.transformPropOrder.indexOf(_key13) !== -1 ? "attr" + _key13.charAt(0).toUpperCase() + _key13.substring(1) : _key13;
      newValues[targetKey] = props[_key13];
    }
  }

  return newValues;
}

var SVGVisualElement = /*#__PURE__*/function (_DOMVisualElement2) {
  _inherits(SVGVisualElement, _DOMVisualElement2);

  var _super4 = _createSuper(SVGVisualElement);

  function SVGVisualElement() {
    var _this8;

    _classCallCheck(this, SVGVisualElement);

    _this8 = _super4.apply(this, arguments);
    _this8.type = "svg";
    _this8.isSVGTag = false;
    _this8.measureInstanceViewportBox = createBox;
    return _this8;
  }

  _createClass(SVGVisualElement, [{
    key: "getBaseTargetFromProps",
    value: function getBaseTargetFromProps(props, key) {
      return props[key];
    }
  }, {
    key: "readValueFromInstance",
    value: function readValueFromInstance(instance, key) {
      if (motionDom.transformProps.has(key)) {
        var defaultType = motionDom.getDefaultValueType(key);
        return defaultType ? defaultType.default || 0 : 0;
      }

      key = !camelCaseAttributes.has(key) ? camelToDash(key) : key;
      return instance.getAttribute(key);
    }
  }, {
    key: "scrapeMotionValuesFromProps",
    value: function scrapeMotionValuesFromProps(props, prevProps, visualElement) {
      return _scrapeMotionValuesFromProps(props, prevProps, visualElement);
    }
  }, {
    key: "build",
    value: function build(renderState, latestValues, props) {
      buildSVGAttrs(renderState, latestValues, this.isSVGTag, props.transformTemplate, props.style);
    }
  }, {
    key: "renderInstance",
    value: function renderInstance(instance, renderState, styleProp, projection) {
      renderSVG(instance, renderState, styleProp, projection);
    }
  }, {
    key: "mount",
    value: function mount(instance) {
      this.isSVGTag = isSVGTag(instance.tagName);

      _get(_getPrototypeOf(SVGVisualElement.prototype), "mount", this).call(this, instance);
    }
  }]);

  return SVGVisualElement;
}(DOMVisualElement);

function createDOMVisualElement(element) {
  var options = {
    presenceContext: null,
    props: {},
    visualState: {
      renderState: {
        transform: {},
        transformOrigin: {},
        style: {},
        vars: {},
        attrs: {}
      },
      latestValues: {}
    }
  };
  var node = motionDom.isSVGElement(element) && !motionDom.isSVGSVGElement(element) ? new SVGVisualElement(options) : new HTMLVisualElement(options);
  node.mount(element);
  visualElementStore.set(element, node);
}

function createObjectVisualElement(subject) {
  var options = {
    presenceContext: null,
    props: {},
    visualState: {
      renderState: {
        output: {}
      },
      latestValues: {}
    }
  };
  var node = new ObjectVisualElement(options);
  node.mount(subject);
  visualElementStore.set(subject, node);
}

function animateSingleValue(value, keyframes, options) {
  var motionValue = motionDom.isMotionValue(value) ? value : motionDom.motionValue(value);
  motionValue.start(animateMotionValue("", motionValue, keyframes, options));
  return motionValue.animation;
}

function isSingleValue(subject, keyframes) {
  return motionDom.isMotionValue(subject) || typeof subject === "number" || typeof subject === "string" && !isDOMKeyframes(keyframes);
}
/**
 * Implementation
 */


function animateSubject(subject, keyframes, options, scope) {
  var animations = [];

  if (isSingleValue(subject, keyframes)) {
    animations.push(animateSingleValue(subject, isDOMKeyframes(keyframes) ? keyframes.default || keyframes : keyframes, options ? options.default || options : options));
  } else {
    var subjects = resolveSubjects(subject, keyframes, scope);
    var numSubjects = subjects.length;
    motionUtils.invariant(Boolean(numSubjects), "No valid elements provided.");

    for (var i = 0; i < numSubjects; i++) {
      var thisSubject = subjects[i];
      var createVisualElement = thisSubject instanceof Element ? createDOMVisualElement : createObjectVisualElement;

      if (!visualElementStore.has(thisSubject)) {
        createVisualElement(thisSubject);
      }

      var visualElement = visualElementStore.get(thisSubject);

      var transition = _objectSpread({}, options);
      /**
       * Resolve stagger function if provided.
       */


      if ("delay" in transition && typeof transition.delay === "function") {
        transition.delay = transition.delay(i, numSubjects);
      }

      animations.push.apply(animations, _toConsumableArray(animateTarget(visualElement, _objectSpread(_objectSpread({}, keyframes), {}, {
        transition: transition
      }), {})));
    }
  }

  return animations;
}

function animateSequence(sequence, options, scope) {
  var animations = [];
  var animationDefinitions = createAnimationsFromSequence(sequence, options, scope, {
    spring: motionDom.spring
  });
  animationDefinitions.forEach(function (_ref16, subject) {
    var keyframes = _ref16.keyframes,
        transition = _ref16.transition;
    animations.push.apply(animations, _toConsumableArray(animateSubject(subject, keyframes, transition)));
  });
  return animations;
}

function isSequence(value) {
  return Array.isArray(value) && value.some(Array.isArray);
}
/**
 * Creates an animation function that is optionally scoped
 * to a specific element.
 */


function createScopedAnimate(scope) {
  /**
   * Implementation
   */
  function scopedAnimate(subjectOrSequence, optionsOrKeyframes, options) {
    var animations = [];

    if (isSequence(subjectOrSequence)) {
      animations = animateSequence(subjectOrSequence, optionsOrKeyframes, scope);
    } else {
      animations = animateSubject(subjectOrSequence, optionsOrKeyframes, options, scope);
    }

    var animation = new motionDom.GroupAnimationWithThen(animations);

    if (scope) {
      scope.animations.push(animation);
      animation.finished.then(function () {
        motionUtils.removeItem(scope.animations, animation);
      });
    }

    return animation;
  }

  return scopedAnimate;
}

var animate = createScopedAnimate();

function animateElements(elementOrSelector, keyframes, options, scope) {
  var elements = motionDom.resolveElements(elementOrSelector, scope);
  var numElements = elements.length;
  motionUtils.invariant(Boolean(numElements), "No valid element provided.");
  /**
   * WAAPI doesn't support interrupting animations.
   *
   * Therefore, starting animations requires a three-step process:
   * 1. Stop existing animations (write styles to DOM)
   * 2. Resolve keyframes (read styles from DOM)
   * 3. Create new animations (write styles to DOM)
   *
   * The hybrid `animate()` function uses AsyncAnimation to resolve
   * keyframes before creating new animations, which removes style
   * thrashing. Here, we have much stricter filesize constraints.
   * Therefore we do this in a synchronous way that ensures that
   * at least within `animate()` calls there is no style thrashing.
   *
   * In the motion-native-animate-mini-interrupt benchmark this
   * was 80% faster than a single loop.
   */

  var animationDefinitions = [];
  /**
   * Step 1: Build options and stop existing animations (write)
   */

  for (var i = 0; i < numElements; i++) {
    var element = elements[i];

    var elementTransition = _objectSpread({}, options);
    /**
     * Resolve stagger function if provided.
     */


    if (typeof elementTransition.delay === "function") {
      elementTransition.delay = elementTransition.delay(i, numElements);
    }

    for (var valueName in keyframes) {
      var valueKeyframes = keyframes[valueName];

      if (!Array.isArray(valueKeyframes)) {
        valueKeyframes = [valueKeyframes];
      }

      var valueOptions = _objectSpread({}, motionDom.getValueTransition(elementTransition, valueName));

      valueOptions.duration && (valueOptions.duration = motionUtils.secondsToMilliseconds(valueOptions.duration));
      valueOptions.delay && (valueOptions.delay = motionUtils.secondsToMilliseconds(valueOptions.delay));
      /**
       * If there's an existing animation playing on this element then stop it
       * before creating a new one.
       */

      var map = motionDom.getAnimationMap(element);

      var _key14 = motionDom.animationMapKey(valueName, valueOptions.pseudoElement || "");

      var currentAnimation = map.get(_key14);
      currentAnimation && currentAnimation.stop();
      animationDefinitions.push({
        map: map,
        key: _key14,
        unresolvedKeyframes: valueKeyframes,
        options: _objectSpread(_objectSpread({}, valueOptions), {}, {
          element: element,
          name: valueName,
          allowFlatten: !elementTransition.type && !elementTransition.ease
        })
      });
    }
  }
  /**
   * Step 2: Resolve keyframes (read)
   */


  for (var _i2 = 0; _i2 < animationDefinitions.length; _i2++) {
    var _animationDefinitions = animationDefinitions[_i2],
        unresolvedKeyframes = _animationDefinitions.unresolvedKeyframes,
        animationOptions = _animationDefinitions.options;
    var _element = animationOptions.element,
        name = animationOptions.name,
        pseudoElement = animationOptions.pseudoElement;

    if (!pseudoElement && unresolvedKeyframes[0] === null) {
      unresolvedKeyframes[0] = motionDom.getComputedStyle(_element, name);
    }

    motionDom.fillWildcards(unresolvedKeyframes);
    motionDom.applyPxDefaults(unresolvedKeyframes, name);
    /**
     * If we only have one keyframe, explicitly read the initial keyframe
     * from the computed style. This is to ensure consistency with WAAPI behaviour
     * for restarting animations, for instance .play() after finish, when it
     * has one vs two keyframes.
     */

    if (!pseudoElement && unresolvedKeyframes.length < 2) {
      unresolvedKeyframes.unshift(motionDom.getComputedStyle(_element, name));
    }

    animationOptions.keyframes = unresolvedKeyframes;
  }
  /**
   * Step 3: Create new animations (write)
   */


  var animations = [];

  var _loop3 = function _loop3(_i3) {
    var _animationDefinitions2 = animationDefinitions[_i3],
        map = _animationDefinitions2.map,
        key = _animationDefinitions2.key,
        animationOptions = _animationDefinitions2.options;
    var animation = new motionDom.NativeAnimation(animationOptions);
    map.set(key, animation);
    animation.finished.finally(function () {
      return map.delete(key);
    });
    animations.push(animation);
  };

  for (var _i3 = 0; _i3 < animationDefinitions.length; _i3++) {
    _loop3(_i3);
  }

  return animations;
}

var createScopedWaapiAnimate = function createScopedWaapiAnimate(scope) {
  function scopedAnimate(elementOrSelector, keyframes, options) {
    return new motionDom.GroupAnimationWithThen(animateElements(elementOrSelector, keyframes, options, scope));
  }

  return scopedAnimate;
};

var animateMini = /*@__PURE__*/createScopedWaapiAnimate();
/**
 * A time in milliseconds, beyond which we consider the scroll velocity to be 0.
 */

var maxElapsed = 50;

var createAxisInfo = function createAxisInfo() {
  return {
    current: 0,
    offset: [],
    progress: 0,
    scrollLength: 0,
    targetOffset: 0,
    targetLength: 0,
    containerLength: 0,
    velocity: 0
  };
};

var createScrollInfo = function createScrollInfo() {
  return {
    time: 0,
    x: createAxisInfo(),
    y: createAxisInfo()
  };
};

var keys = {
  x: {
    length: "Width",
    position: "Left"
  },
  y: {
    length: "Height",
    position: "Top"
  }
};

function updateAxisInfo(element, axisName, info, time) {
  var axis = info[axisName];
  var _keys$axisName = keys[axisName],
      length = _keys$axisName.length,
      position = _keys$axisName.position;
  var prev = axis.current;
  var prevTime = info.time;
  axis.current = element["scroll".concat(position)];
  axis.scrollLength = element["scroll".concat(length)] - element["client".concat(length)];
  axis.offset.length = 0;
  axis.offset[0] = 0;
  axis.offset[1] = axis.scrollLength;
  axis.progress = motionUtils.progress(0, axis.scrollLength, axis.current);
  var elapsed = time - prevTime;
  axis.velocity = elapsed > maxElapsed ? 0 : motionUtils.velocityPerSecond(axis.current - prev, elapsed);
}

function updateScrollInfo(element, info, time) {
  updateAxisInfo(element, "x", info, time);
  updateAxisInfo(element, "y", info, time);
  info.time = time;
}

function calcInset(element, container) {
  var inset = {
    x: 0,
    y: 0
  };
  var current = element;

  while (current && current !== container) {
    if (motionDom.isHTMLElement(current)) {
      inset.x += current.offsetLeft;
      inset.y += current.offsetTop;
      current = current.offsetParent;
    } else if (current.tagName === "svg") {
      /**
       * This isn't an ideal approach to measuring the offset of <svg /> tags.
       * It would be preferable, given they behave like HTMLElements in most ways
       * to use offsetLeft/Top. But these don't exist on <svg />. Likewise we
       * can't use .getBBox() like most SVG elements as these provide the offset
       * relative to the SVG itself, which for <svg /> is usually 0x0.
       */
      var svgBoundingBox = current.getBoundingClientRect();
      current = current.parentElement;
      var parentBoundingBox = current.getBoundingClientRect();
      inset.x += svgBoundingBox.left - parentBoundingBox.left;
      inset.y += svgBoundingBox.top - parentBoundingBox.top;
    } else if (current instanceof SVGGraphicsElement) {
      var _current$getBBox = current.getBBox(),
          x = _current$getBBox.x,
          y = _current$getBBox.y;

      inset.x += x;
      inset.y += y;
      var svg = null;
      var parent = current.parentNode;

      while (!svg) {
        if (parent.tagName === "svg") {
          svg = parent;
        }

        parent = current.parentNode;
      }

      current = svg;
    } else {
      break;
    }
  }

  return inset;
}

var namedEdges = {
  start: 0,
  center: 0.5,
  end: 1
};

function resolveEdge(edge, length) {
  var inset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  var delta = 0;
  /**
   * If we have this edge defined as a preset, replace the definition
   * with the numerical value.
   */

  if (edge in namedEdges) {
    edge = namedEdges[edge];
  }
  /**
   * Handle unit values
   */


  if (typeof edge === "string") {
    var asNumber = parseFloat(edge);

    if (edge.endsWith("px")) {
      delta = asNumber;
    } else if (edge.endsWith("%")) {
      edge = asNumber / 100;
    } else if (edge.endsWith("vw")) {
      delta = asNumber / 100 * document.documentElement.clientWidth;
    } else if (edge.endsWith("vh")) {
      delta = asNumber / 100 * document.documentElement.clientHeight;
    } else {
      edge = asNumber;
    }
  }
  /**
   * If the edge is defined as a number, handle as a progress value.
   */


  if (typeof edge === "number") {
    delta = length * edge;
  }

  return inset + delta;
}

var defaultOffset = [0, 0];

function resolveOffset(offset, containerLength, targetLength, targetInset) {
  var offsetDefinition = Array.isArray(offset) ? offset : defaultOffset;
  var targetPoint = 0;
  var containerPoint = 0;

  if (typeof offset === "number") {
    /**
     * If we're provided offset: [0, 0.5, 1] then each number x should become
     * [x, x], so we default to the behaviour of mapping 0 => 0 of both target
     * and container etc.
     */
    offsetDefinition = [offset, offset];
  } else if (typeof offset === "string") {
    offset = offset.trim();

    if (offset.includes(" ")) {
      offsetDefinition = offset.split(" ");
    } else {
      /**
       * If we're provided a definition like "100px" then we want to apply
       * that only to the top of the target point, leaving the container at 0.
       * Whereas a named offset like "end" should be applied to both.
       */
      offsetDefinition = [offset, namedEdges[offset] ? offset : "0"];
    }
  }

  targetPoint = resolveEdge(offsetDefinition[0], targetLength, targetInset);
  containerPoint = resolveEdge(offsetDefinition[1], containerLength);
  return targetPoint - containerPoint;
}

var ScrollOffset = {
  Enter: [[0, 1], [1, 1]],
  Exit: [[0, 0], [1, 0]],
  Any: [[1, 0], [0, 1]],
  All: [[0, 0], [1, 1]]
};
var point = {
  x: 0,
  y: 0
};

function getTargetSize(target) {
  return "getBBox" in target && target.tagName !== "svg" ? target.getBBox() : {
    width: target.clientWidth,
    height: target.clientHeight
  };
}

function resolveOffsets(container, info, options) {
  var _options$offset = options.offset,
      offsetDefinition = _options$offset === void 0 ? ScrollOffset.All : _options$offset;
  var _options$target = options.target,
      target = _options$target === void 0 ? container : _options$target,
      _options$axis = options.axis,
      axis = _options$axis === void 0 ? "y" : _options$axis;
  var lengthLabel = axis === "y" ? "height" : "width";
  var inset = target !== container ? calcInset(target, container) : point;
  /**
   * Measure the target and container. If they're the same thing then we
   * use the container's scrollWidth/Height as the target, from there
   * all other calculations can remain the same.
   */

  var targetSize = target === container ? {
    width: container.scrollWidth,
    height: container.scrollHeight
  } : getTargetSize(target);
  var containerSize = {
    width: container.clientWidth,
    height: container.clientHeight
  };
  /**
   * Reset the length of the resolved offset array rather than creating a new one.
   * TODO: More reusable data structures for targetSize/containerSize would also be good.
   */

  info[axis].offset.length = 0;
  /**
   * Populate the offset array by resolving the user's offset definition into
   * a list of pixel scroll offets.
   */

  var hasChanged = !info[axis].interpolate;
  var numOffsets = offsetDefinition.length;

  for (var i = 0; i < numOffsets; i++) {
    var offset = resolveOffset(offsetDefinition[i], containerSize[lengthLabel], targetSize[lengthLabel], inset[axis]);

    if (!hasChanged && offset !== info[axis].interpolatorOffsets[i]) {
      hasChanged = true;
    }

    info[axis].offset[i] = offset;
  }
  /**
   * If the pixel scroll offsets have changed, create a new interpolator function
   * to map scroll value into a progress.
   */


  if (hasChanged) {
    info[axis].interpolate = motionDom.interpolate(info[axis].offset, motionDom.defaultOffset(offsetDefinition), {
      clamp: false
    });
    info[axis].interpolatorOffsets = _toConsumableArray(info[axis].offset);
  }

  info[axis].progress = motionUtils.clamp(0, 1, info[axis].interpolate(info[axis].current));
}

function _measure(container) {
  var target = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : container;
  var info = arguments.length > 2 ? arguments[2] : undefined;

  /**
   * Find inset of target within scrollable container
   */
  info.x.targetOffset = 0;
  info.y.targetOffset = 0;

  if (target !== container) {
    var node = target;

    while (node && node !== container) {
      info.x.targetOffset += node.offsetLeft;
      info.y.targetOffset += node.offsetTop;
      node = node.offsetParent;
    }
  }

  info.x.targetLength = target === container ? target.scrollWidth : target.clientWidth;
  info.y.targetLength = target === container ? target.scrollHeight : target.clientHeight;
  info.x.containerLength = container.clientWidth;
  info.y.containerLength = container.clientHeight;
  /**
   * In development mode ensure scroll containers aren't position: static as this makes
   * it difficult to measure their relative positions.
   */

  if (process.env.NODE_ENV !== "production") {
    if (container && target && target !== container) {
      motionUtils.warnOnce(getComputedStyle(container).position !== "static", "Please ensure that the container has a non-static position, like 'relative', 'fixed', or 'absolute' to ensure scroll offset is calculated correctly.");
    }
  }
}

function createOnScrollHandler(element, onScroll, info) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  return {
    measure: function measure(time) {
      _measure(element, options.target, info);

      updateScrollInfo(element, info, time);

      if (options.offset || options.target) {
        resolveOffsets(element, info, options);
      }
    },
    notify: function notify() {
      return onScroll(info);
    }
  };
}

var scrollListeners = new WeakMap();
var resizeListeners = new WeakMap();
var onScrollHandlers = new WeakMap();

var getEventTarget = function getEventTarget(element) {
  return element === document.scrollingElement ? window : element;
};

function scrollInfo(onScroll) {
  var _ref17 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref17$container = _ref17.container,
      container = _ref17$container === void 0 ? document.scrollingElement : _ref17$container,
      options = _objectWithoutProperties(_ref17, ["container"]);

  if (!container) return motionUtils.noop;
  var containerHandlers = onScrollHandlers.get(container);
  /**
   * Get the onScroll handlers for this container.
   * If one isn't found, create a new one.
   */

  if (!containerHandlers) {
    containerHandlers = new Set();
    onScrollHandlers.set(container, containerHandlers);
  }
  /**
   * Create a new onScroll handler for the provided callback.
   */


  var info = createScrollInfo();
  var containerHandler = createOnScrollHandler(container, onScroll, info, options);
  containerHandlers.add(containerHandler);
  /**
   * Check if there's a scroll event listener for this container.
   * If not, create one.
   */

  if (!scrollListeners.has(container)) {
    var measureAll = function measureAll() {
      var _iterator = _createForOfIteratorHelper(containerHandlers),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var handler = _step.value;
          handler.measure(motionDom.frameData.timestamp);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      motionDom.frame.preUpdate(notifyAll);
    };

    var notifyAll = function notifyAll() {
      var _iterator2 = _createForOfIteratorHelper(containerHandlers),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var handler = _step2.value;
          handler.notify();
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    };

    var _listener = function _listener() {
      return motionDom.frame.read(measureAll);
    };

    scrollListeners.set(container, _listener);
    var target = getEventTarget(container);
    window.addEventListener("resize", _listener, {
      passive: true
    });

    if (container !== document.documentElement) {
      resizeListeners.set(container, motionDom.resize(container, _listener));
    }

    target.addEventListener("scroll", _listener, {
      passive: true
    });

    _listener();
  }

  var listener = scrollListeners.get(container);
  motionDom.frame.read(listener, false, true);
  return function () {
    motionDom.cancelFrame(listener);
    /**
     * Check if we even have any handlers for this container.
     */

    var currentHandlers = onScrollHandlers.get(container);
    if (!currentHandlers) return;
    currentHandlers.delete(containerHandler);
    if (currentHandlers.size) return;
    /**
     * If no more handlers, remove the scroll listener too.
     */

    var scrollListener = scrollListeners.get(container);
    scrollListeners.delete(container);

    if (scrollListener) {
      var _resizeListeners$get;

      getEventTarget(container).removeEventListener("scroll", scrollListener);
      (_resizeListeners$get = resizeListeners.get(container)) === null || _resizeListeners$get === void 0 ? void 0 : _resizeListeners$get();
      window.removeEventListener("resize", scrollListener);
    }
  };
}

var timelineCache = new Map();

function scrollTimelineFallback(options) {
  var currentTime = {
    value: 0
  };
  var cancel = scrollInfo(function (info) {
    currentTime.value = info[options.axis].progress * 100;
  }, options);
  return {
    currentTime: currentTime,
    cancel: cancel
  };
}

function getTimeline(_ref18) {
  var _timelineCache$get, _options$target2, _containerCache$get, _options$offset2;

  var source = _ref18.source,
      container = _ref18.container,
      options = _objectWithoutProperties(_ref18, ["source", "container"]);

  var axis = options.axis;
  if (source) container = source;
  var containerCache = (_timelineCache$get = timelineCache.get(container)) !== null && _timelineCache$get !== void 0 ? _timelineCache$get : new Map();
  timelineCache.set(container, containerCache);
  var targetKey = (_options$target2 = options.target) !== null && _options$target2 !== void 0 ? _options$target2 : "self";
  var targetCache = (_containerCache$get = containerCache.get(targetKey)) !== null && _containerCache$get !== void 0 ? _containerCache$get : {};
  var axisKey = axis + ((_options$offset2 = options.offset) !== null && _options$offset2 !== void 0 ? _options$offset2 : []).join(",");

  if (!targetCache[axisKey]) {
    targetCache[axisKey] = !options.target && motionDom.supportsScrollTimeline() ? new ScrollTimeline({
      source: container,
      axis: axis
    }) : scrollTimelineFallback(_objectSpread({
      container: container
    }, options));
  }

  return targetCache[axisKey];
}

function attachToAnimation(animation, options) {
  var timeline = getTimeline(options);
  return animation.attachTimeline({
    timeline: options.target ? undefined : timeline,
    observe: function observe(valueAnimation) {
      valueAnimation.pause();
      return motionDom.observeTimeline(function (progress) {
        valueAnimation.time = valueAnimation.duration * progress;
      }, timeline);
    }
  });
}
/**
 * If the onScroll function has two arguments, it's expecting
 * more specific information about the scroll from scrollInfo.
 */


function isOnScrollWithInfo(onScroll) {
  return onScroll.length === 2;
}

function attachToFunction(onScroll, options) {
  if (isOnScrollWithInfo(onScroll)) {
    return scrollInfo(function (info) {
      onScroll(info[options.axis].progress, info);
    }, options);
  } else {
    return motionDom.observeTimeline(onScroll, getTimeline(options));
  }
}

function scroll(onScroll) {
  var _ref19 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref19$axis = _ref19.axis,
      axis = _ref19$axis === void 0 ? "y" : _ref19$axis,
      _ref19$container = _ref19.container,
      container = _ref19$container === void 0 ? document.scrollingElement : _ref19$container,
      options = _objectWithoutProperties(_ref19, ["axis", "container"]);

  if (!container) return motionUtils.noop;

  var optionsWithDefaults = _objectSpread({
    axis: axis,
    container: container
  }, options);

  return typeof onScroll === "function" ? attachToFunction(onScroll, optionsWithDefaults) : attachToAnimation(onScroll, optionsWithDefaults);
}

var thresholds = {
  some: 0,
  all: 1
};

function inView(elementOrSelector, onStart) {
  var _ref20 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      root = _ref20.root,
      rootMargin = _ref20.margin,
      _ref20$amount = _ref20.amount,
      amount = _ref20$amount === void 0 ? "some" : _ref20$amount;

  var elements = motionDom.resolveElements(elementOrSelector);
  var activeIntersections = new WeakMap();

  var onIntersectionChange = function onIntersectionChange(entries) {
    entries.forEach(function (entry) {
      var onEnd = activeIntersections.get(entry.target);
      /**
       * If there's no change to the intersection, we don't need to
       * do anything here.
       */

      if (entry.isIntersecting === Boolean(onEnd)) return;

      if (entry.isIntersecting) {
        var newOnEnd = onStart(entry.target, entry);

        if (typeof newOnEnd === "function") {
          activeIntersections.set(entry.target, newOnEnd);
        } else {
          observer.unobserve(entry.target);
        }
      } else if (typeof onEnd === "function") {
        onEnd(entry);
        activeIntersections.delete(entry.target);
      }
    });
  };

  var observer = new IntersectionObserver(onIntersectionChange, {
    root: root,
    rootMargin: rootMargin,
    threshold: typeof amount === "number" ? amount : thresholds[amount]
  });
  elements.forEach(function (element) {
    return observer.observe(element);
  });
  return function () {
    return observer.disconnect();
  };
}

function getOriginIndex(from, total) {
  if (from === "first") {
    return 0;
  } else {
    var lastIndex = total - 1;
    return from === "last" ? lastIndex : lastIndex / 2;
  }
}

function stagger() {
  var duration = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0.1;

  var _ref21 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref21$startDelay = _ref21.startDelay,
      startDelay = _ref21$startDelay === void 0 ? 0 : _ref21$startDelay,
      _ref21$from = _ref21.from,
      from = _ref21$from === void 0 ? 0 : _ref21$from,
      ease = _ref21.ease;

  return function (i, total) {
    var fromIndex = typeof from === "number" ? from : getOriginIndex(from, total);
    var distance = Math.abs(fromIndex - i);
    var delay = duration * distance;

    if (ease) {
      var maxDelay = total * duration;
      var easingFunction = motionUtils.easingDefinitionToFunction(ease);
      delay = easingFunction(delay / maxDelay) * maxDelay;
    }

    return startDelay + delay;
  };
}
/**
 * Timeout defined in ms
 */


function delay(callback, timeout) {
  var start = motionDom.time.now();

  var checkElapsed = function checkElapsed(_ref22) {
    var timestamp = _ref22.timestamp;
    var elapsed = timestamp - start;

    if (elapsed >= timeout) {
      motionDom.cancelFrame(checkElapsed);
      callback(elapsed - timeout);
    }
  };

  motionDom.frame.setup(checkElapsed, true);
  return function () {
    return motionDom.cancelFrame(checkElapsed);
  };
}

function delayInSeconds(callback, timeout) {
  return delay(callback, motionUtils.secondsToMilliseconds(timeout));
}

var distance = function distance(a, b) {
  return Math.abs(a - b);
};

function distance2D(a, b) {
  // Multi-dimensional
  var xDelta = distance(a.x, b.x);
  var yDelta = distance(a.y, b.y);
  return Math.sqrt(Math.pow(xDelta, 2) + Math.pow(yDelta, 2));
}

exports.animate = animate;
exports.animateMini = animateMini;
exports.createScopedAnimate = createScopedAnimate;
exports.delay = delayInSeconds;
exports.distance = distance;
exports.distance2D = distance2D;
exports.inView = inView;
exports.scroll = scroll;
exports.scrollInfo = scrollInfo;
exports.stagger = stagger;
Object.keys(motionDom).forEach(function (k) {
  if (k !== 'default' && !Object.prototype.hasOwnProperty.call(exports, k)) Object.defineProperty(exports, k, {
    enumerable: true,
    get: function get() {
      return motionDom[k];
    }
  });
});
Object.keys(motionUtils).forEach(function (k) {
  if (k !== 'default' && !Object.prototype.hasOwnProperty.call(exports, k)) Object.defineProperty(exports, k, {
    enumerable: true,
    get: function get() {
      return motionUtils[k];
    }
  });
});